import { animate, style, transition, trigger } from '@angular/animations';

export const addRemoveAnimation = trigger('addRemoveAnimation', [
  // Item added
  transition(':enter', [
    style({ opacity: 0, transform: 'translateY(-20px)' }),
    animate('500ms ease-out', style({ opacity: 1, transform: 'translateY(0)' })),
  ]),

  // Item removed
  transition(':leave', [animate('300ms ease-in', style({ opacity: 0, transform: 'translateY(20px)' }))]),
]);
